import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CartItem } from '@pedix-workspace/utils';
import {
  IconCheckComponent,
  IconChevronRightComponent,
  IconNoteComponent,
  IconPlusSignComponent,
} from '@pedix-workspace/angular-ui-icons';

@Component({
  selector: 'pxw-cart-order-item',
  templateUrl: './cart-order-item.component.html',
  styleUrls: ['./cart-order-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IconCheckComponent,
    IconChevronRightComponent,
    IconNoteComponent,
    IconPlusSignComponent,
  ],
})
export class CartOrderItemComponent {
  readonly cartItem = input.required<CartItem>();
  readonly readOnly = input(false);
  readonly isOutOfStock = input.required<boolean>();
  readonly isCategoryAvailable = input.required<boolean>();
  readonly hasOptions = input.required<boolean>();
  readonly observations = input<string | undefined>(undefined);
  readonly availableOptionsLabel = input('');
  readonly displaySelector = input(false);
  readonly selected = input(false);

  readonly edit = output<CartItem>();
  readonly remove = output<CartItem>();
  readonly selectedChange = output<boolean>();

  onItemClick() {
    if (this.displaySelector()) {
      this.selectedChange.emit(!this.selected());

      return;
    }
    this.onEdit();
  }

  onSelectorChange(event: Event) {
    event.stopPropagation();

    this.selectedChange.emit((event.target as HTMLInputElement).checked);
  }

  onEdit() {
    if (this.readOnly() || !this.isCategoryAvailable() || this.isOutOfStock()) {
      return;
    }
    this.edit.emit(this.cartItem());
  }
}
